import type { IChatListObject, IDedupeChatsByUuidProps } from "../types/chat";

// NOTE: NSAI-4792 — collapses repeated chats out of a flattened
// IChatListPage[]. The first occurrence wins: pages are flattened in ascending
// offset order, so the earliest one is the position the server reported for the
// lowest offset, which is where the list should show it. Keeping the later copy
// instead would make a chat appear to jump down the list for the duration of a
// refetch.
export const dedupeChatsByUuid = ({
  chats,
}: IDedupeChatsByUuidProps): IChatListObject[] => {
  const seenChatUuids = new Set<string>();

  return chats.filter((chat) => {
    if (seenChatUuids.has(chat.uuid)) {
      return false;
    }

    seenChatUuids.add(chat.uuid);
    return true;
  });
};
